export default {
  DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION',
  CHANGE_ACTIVE_PASSENGER: 'CHANGE_ACTIVE_PASSENGER',
  CHANGE_ACTIVE_STEP: 'CHANGE_ACTIVE_STEP',
};



// WEBPACK FOOTER //
// ./src/redux/constants/GlobalConstants.js